<template>
  <div>
    <ApplicationsEmptyState v-if="currentTabApplications.length === 0" :currentTab="currentTab" />
    <div v-else>
      <ColumnTips
        v-if="currentTab !== 'NOT_A_FIT'"
        :currentTab="currentTab"
        :numberOfApplicants="currentTabApplications.length"
      />
      <ul class="sitter-list mt-16 md:mt-0">
        <li
          v-for="{ id, sitter } in currentTabApplications"
          :id="id"
          :key="id"
          :class="selectedApplicationUuid === id ? 'selected-application' : ''"
          class="w-full shadow-none md:border-b-1 border-grey-divider-subdued border-solid rounded-none first:md:border-t-1 last:-mb-1 px-16 pb-16 md:p-0"
        >
          <button class="inner-focus inline-block w-full" @click="navigateToApplication(id)">
            <SitterCard
              :class="`w-full md:shadow-none ${selectedApplicationUuid === id ? 'bg-grey-background-contrast' : ''}`"
              :photoUrl="sitter.photoUrl"
              :name="sitter.displayName"
              :yearsExperience="
                sitter.careTypeDetails?.[$store.getters['applications/applicantCareTypeKey']]?.yearsExperience ||
                sitter.yearsExperience ||
                0
              "
              :city="sitter.location.cityname"
              :stateAbbr="sitter.location.stateabbr"
              :totalRatings="sitter.reviews.totalReviewCount"
              :avgRating="sitter.reviews.starAggregate"
            />
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import ApplicationsEmptyState from './ApplicationsEmptyState.vue';
import ColumnTips from '../ReplyContainer/ColumnTips.vue';
import SitterCard from '../../../components/sitter_card/SitterCard.vue';

export default {
  name: 'ApplicantList',
  components: {
    ApplicationsEmptyState,
    ColumnTips,

    SitterCard,
  },
  props: {
    currentTabApplications: {
      required: true,
      type: Array<{ id: string; sitter: any }>,
    },
    navigateToApplication: {
      required: true,
      type: Function,
    },
    currentTab: {
      type: String,
      required: true,
    },
  },
  computed: {
    isNotAFit(): boolean {
      return this.$store.getters['applications/applicationDetails'].parentInterestStatus === 'NOT_A_FIT';
    },
    selectedApplicationUuid(): string {
      return this.$route.params.application_uuid;
    },
  },
};
</script>
